// TimerDisplay.jsx
import { useContext, useEffect, useState } from "react";
import { useTimer } from "./TimerContext";
import { SocketContext } from "../context/SocketProvider";
import { useLanguage } from "./LanguageContext";
import { DEFAULT_ROOM } from "../constants/gameStages";

/**
 * TimerDisplay component shows the remaining time in a formatted way.
 * It uses the TimerContext to access the current time remaining.
 */
export const TimerDisplay = () => {
  const { timeRemaining } = useTimer();
  const { role, socket } = useContext(SocketContext);
  const [currentRound, setCurrentRound] = useState(1);
  const { t } = useLanguage();

  useEffect(() => {
    if (!socket) return;

    // Listen for game data updates to get the round
    const handleGameData = (data) => {
      // console.log("Timer display received game data:", data);
      if (data.round) {
        setCurrentRound(data.round);
      }
    };

    socket.on("game_data", handleGameData);

    // Request current game data to get the round
    socket.emit("get_game_data", { room: DEFAULT_ROOM });

    return () => {
      socket.off("game_data", handleGameData);
    };
  }, [socket]);

  // Only render after gameStage and role are set
  if (!role) {
    return;
  }
  const minutes = Math.floor(timeRemaining / 60);
  const seconds = timeRemaining % 60;

  const color = role === "describer" ? "bg-pink300" : "bg-blue300";

  // Replace round/totalRounds with context values
  const totalRounds = 4;
  return (
    <div data-rounds="true" className="w-48 h-24 relative">
      <div
        className={`w-48 h-24 left-0 top-4 absolute ${color} rounded-bl-2xl rounded-br-2xl`}
      />
      <div className="absolute left-1/2 top-[56px] -translate-x-1/2 text-center justify-center text-white text-4xl font-bold font-['Gabarito']">
        {`${minutes.toString().padStart(2, "0")}:${seconds
          .toString()
          .padStart(2, "0")}`}
      </div>
      <div className="absolute left-1/2 top-[32px] -translate-x-1/2 text-center justify-center text-white text-base font-bold font-['Gabarito'] whitespace-nowrap">
        {`${t('score.round', 'ROUND')} ${currentRound}/${totalRounds}`}
      </div>
    </div>
  );
};
